module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_92-585e005119a166067c4127ac55730c89.png";